import { AdobeResponse } from '../../models/campaign/adobe.response.interface';

export const mockAdobeResponse: AdobeResponse = {
  result: 'Reply from Mc: wpThankYouForRegistering',
};
